import { render, staticRenderFns } from "./InitiateProcess.vue?vue&type=template&id=76c00d61&scoped=true&"
import script from "./InitiateProcess.vue?vue&type=script&lang=js&"
export * from "./InitiateProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c00d61",
  null
  
)

export default component.exports